/* eslint-disable no-nested-ternary */
/* eslint-disable react/jsx-props-no-spreading */
import { Boundary, ImageLoader } from 'components/common';
import { useDocumentTitle, useScrollTop } from 'hooks';
import { displayActionMessage } from 'helpers/utils';
import { useSelector } from 'react-redux';
import { ADMIN_PRODUCTS_EDIT } from 'constants/routes';
import React, { useEffect, useMemo, useState } from 'react';
import { withRouter, useHistory } from 'react-router-dom';
import firebase from 'firebase/firebase';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import { query, collection, where } from 'firebase/firestore';
import { useCollection } from 'react-firebase-hooks/firestore';
import { useTranslation } from 'react-i18next';
import {
  usePagination,
  useTable,
  useSortBy,
  useGlobalFilter
} from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faEdit,
  faLink,
  faStarHalfAlt,
  faTrash
} from '@fortawesome/free-solid-svg-icons';
import { CustomTable } from '../../../components/common';

const Products = () => {
  const { t } = useTranslation();
  useDocumentTitle('Admin - Uilpi');
  useScrollTop();
  useEffect(() => {
    document.body.classList.add('no-scroll');
    return () => {
      document.body.classList.remove('no-scroll');
    };
  });

  const history = useHistory();
  const store = useSelector((state) => ({
    user: state.auth
  }));

  const onClickOpenLink = (id) => {
    window.open(`/product/${id}`, '_blank');
  };

  const onClickEdit = (id) => {
    history.push(`${ADMIN_PRODUCTS_EDIT}/${id}`);
  };

  const onClickToggleFeatured = async (e, id) => {
    e.target.closest('tr').classList.toggle('item-active-waiting');
    await firebase.toggleFeatured(id).catch((error) => {
      console.error(error);
      displayActionMessage('errorMessage1', 'error');
    });
    e.target.closest('tr').classList.toggle('item-active-waiting');
  };

  const onDeleteProduct = (e) => {
    e.target.closest('tr').classList.toggle('item-active');
  };

  const onConfirmDelete = async (e, id) => {
    await firebase
      .removeProductByAdmin(id)
      .then(() => displayActionMessage('successProductDeleted', 'success'))
      .catch(() => displayActionMessage('errorMessage1', 'error'));
    e.target.closest('tr').classList.toggle('item-active');
  };

  const onCancelDelete = (e) => {
    e.target.closest('tr').classList.toggle('item-active');
  };

  const [featuredProducts, isLoadingFeatured] = useCollection(
    query(collection(firebase.db, 'products'), where('featured', '==', true)),
    {
      snapshotListenOptions: { includeMetadataChanges: true }
    }
  );

  const [nonFeaturedProducts, isLoadingNonFeatured] = useCollection(
    query(
      collection(firebase.db, 'products'),
      where('featured', '==', false),
      where('userId', '!=', store.user.id)
    ),
    {
      snapshotListenOptions: { includeMetadataChanges: true }
    }
  );

  const [adminProducts, isLoadingAdmin] = useCollection(
    query(
      collection(firebase.db, 'products'),
      where('featured', '==', false),
      where('userId', '==', store.user.id)
    ),
    {
      snapshotListenOptions: { includeMetadataChanges: true }
    }
  );

  const [dataFeatured, setDataFeatured] = useState([]);
  const [dataNonFeatured, setDataNonFeatured] = useState([]);
  const [dataAdmin, setDataAdmin] = useState([]);

  const dataFetch = (snapshot) => {
    const rows = [];
    snapshot.docs.map((product) =>
      rows.push({
        col1: (
          <div className="grid-admin item-img-wrapper">
            {product.data().image ? (
              <ImageLoader
                alt={product.data().name}
                className="item-img"
                src={product.data().image}
              />
            ) : (
              <Skeleton width={50} height={30} />
            )}
          </div>
        ),
        col2: product.data().name || <Skeleton width={50} />,
        col3: new Date(product.data().dateAdded) || <Skeleton width={50} />,
        col4:
          typeof product.data().sold === 'undefined' ? (
            <Skeleton width={30} />
          ) : (
            [
              product.data().sold ? t('productSold') : t('productNotSold')
            ].toString()
          ),
        col5: product.data().address.country,
        col6: product.data().userId || <Skeleton width={30} />,
        col7: (
          <div className="item-action">
            {product.data().userId === store.user.id && (
              <>
                <button
                  className="button button-small"
                  onClick={() => onClickEdit(product.id)}
                  type="button"
                >
                  <FontAwesomeIcon icon={faEdit} />
                </button>
                &nbsp;
              </>
            )}
            <button
              className="button button-small"
              onClick={() => onClickOpenLink(product.id)}
              type="button"
            >
              <FontAwesomeIcon icon={faLink} />
            </button>
            &nbsp;
            <button
              className="button button-small"
              onClick={(e) => onClickToggleFeatured(e, product.id)}
              type="button"
            >
              <FontAwesomeIcon icon={faStarHalfAlt} />
            </button>
            &nbsp;
            <button
              className="button button-small button-danger"
              onClick={(e) => onDeleteProduct(e)}
              type="button"
            >
              <FontAwesomeIcon icon={faTrash} />
            </button>
            <div className="item-action-confirm">
              <h5>{t('productDeleteConfirm')}</h5>
              <button
                className="button button-small button-border"
                onClick={(e) => onCancelDelete(e)}
                type="button"
              >
                {t('noMessage')}
              </button>
              &nbsp;
              <button
                className="button button-small button-danger"
                onClick={(e) => onConfirmDelete(e, product.id)}
                type="button"
              >
                {t('yesMessage')}
              </button>
            </div>
          </div>
        )
      })
    );
    return rows;
  };

  useEffect(() => {
    if (!isLoadingFeatured && featuredProducts) {
      const result = dataFetch(featuredProducts);
      setDataFeatured(result);
    }
  }, [featuredProducts]);
  useEffect(() => {
    if (!isLoadingNonFeatured && nonFeaturedProducts) {
      const result = dataFetch(nonFeaturedProducts);
      setDataNonFeatured(result);
    }
  }, [nonFeaturedProducts]);
  useEffect(() => {
    if (!isLoadingAdmin && adminProducts) {
      const result = dataFetch(adminProducts);
      setDataAdmin(result);
    }
  }, [adminProducts]);

  const columns = useMemo(
    () => [
      {
        Header: t('productTableImage'),
        accessor: 'col1',
        disableSortBy: true
      },
      {
        Header: t('productTableName'),
        accessor: 'col2'
      },
      {
        Header: t('productTableDate'),
        accessor: 'col3',
        sortType: 'datetime'
      },
      {
        Header: t('productTableState'),
        accessor: 'col4'
      },
      {
        Header: 'Country',
        accessor: 'col5'
      },
      {
        Header: 'User ID',
        accessor: 'col6'
      },
      {
        Header: '',
        accessor: 'col7',
        disableSortBy: true
      }
    ],
    []
  );

  const tableInstanceFeatured = useTable(
    { columns, data: dataFeatured, initialState: { pageSize: 10 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const tableInstanceNonFeatured = useTable(
    { columns, data: dataNonFeatured, initialState: { pageSize: 10 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );
  const tableInstanceAdmin = useTable(
    { columns, data: dataAdmin, initialState: { pageSize: 10 } },
    useGlobalFilter,
    useSortBy,
    usePagination
  );

  return (
    <Boundary>
      <CustomTable
        tableInstance={tableInstanceFeatured}
        title={t('featuredMessage')}
        paragraph={t('adminFeaturedParagraph')}
      />
      <br />
      <br />
      <CustomTable
        tableInstance={tableInstanceNonFeatured}
        title={t('adminOtherProducts')}
      />
      <br />
      <br />
      <CustomTable tableInstance={tableInstanceAdmin} title="Admin" button />
    </Boundary>
  );
};

export default withRouter(Products);
